if (!customElements.get('cc-product-grid')) {
  customElements.define('cc-product-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        if (event.target.closest('[data-cc-close]')) {
          this.dialog.close();
          return;
        }
        const link = event.target.closest('[data-cc-zoom]');
        if (!link || !this.dialog?.showModal) return;
        event.preventDefault();
        const source = link.querySelector('img');
        const image = this.dialog.querySelector('img');
        image.src = link.href;
        image.alt = source.alt;
        this.dialog.showModal();
      }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, { signal });
      this.mediaQuery = matchMedia('(min-width: 981px)');
      this.mediaQuery.addEventListener('change', () => {
        if (!this.mediaQuery.matches && this.dialog.open) this.dialog.close();
      }, { signal });
    }
    disconnectedCallback() {
      this.dialog?.close();
      this.abortController?.abort();
      this.abortController = null;
    }
  });
}
